import SendIcon from "../assets/icons/send_icon.svg";
import {useContext, useState} from "react";
import {HomeContext} from "../context/HomeContext";
import {useNavigate} from "react-router-dom";

const ChatBotInput = ({inputNewChat = false}) => {

    const navigate = useNavigate();

    const {setQuery, setNewChat} = useContext(HomeContext);

    const [inputQuery, setInputQuery] = useState("")

    const handleOnChange = (e) => {
        setInputQuery(e.target.value)
    }

    const handleInputSubmit = (e) => {
        e.preventDefault();
        setQuery(inputQuery)
        setInputQuery("")
        if (inputNewChat) {
            setNewChat(true)
            const chat_id = crypto.randomUUID()
            navigate(`/chat/${chat_id}`)
        }
    }

    return (
        <form className="chatbot-input" onSubmit={handleInputSubmit}>
            <input type="text" className={"placeholder"}
                   onChange={handleOnChange} value={inputQuery}
                   placeholder={"Send Message to Sustainability Agent"}
            />
            <button type={"submit"} className="submit-button">
                <img src={SendIcon} alt=""/>
            </button>
        </form>
    )
}

export default ChatBotInput;